import { useMyTranslation } from "@becon-team/becon-fe-lib/my-i18n";
import { BottomSheetModal, useModal } from "@becon-team/becon-fe-lib/my-modal";
import { sleep } from "@becon-team/becon-fe-lib/utils";
import { modalIds } from "libs/my-modal";
import { useCallback, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { getDeviceInfo } from "utils/nativeApi";
import { scannerState } from "bridge/store/scannerState";
import { useScalpShooting } from "bridge/hooks/(useScalpShotting)";
import { useAppSelector } from "store/redux/modules";
import { getUserId, getUserName } from "store/redux/modules/user";

export const CheckScannerModal = () => {
  const modalId = modalIds["check-scanner"];
  const { t } = useMyTranslation();

  const unknown = t("알수없음");
  const userId = useAppSelector(getUserId);
  const userNickname = useAppSelector(getUserName);

  const { modal, closeModal } = useModal(modalId);
  const { isOpened } = modal;
  const { scalpShooting } = useScalpShooting();
  useEffect(() => {
    getDeviceInfo();
  }, []);

  const scanner = useRecoilValue(scannerState);
  const scannerInfos: {
    label: string;
    info: string;
  }[] = [
    {
      label: t("배터리"),
      info: scanner?.device?.battery ? `${scanner?.device.battery}%` : unknown,
    },
    {
      label: t("스캐너명"),
      info: scanner?.device?.name ?? unknown,
    },
    ...(scanner?.device?.wifiName
      ? [
          {
            label: t("와이파이"),
            info: scanner.device.wifiName,
          },
        ]
      : []),
    {
      label: t("OS 버전"),
      info: scanner?.device?.os ?? unknown,
    },
  ];

  const handleChangeScanner = async () => {
    closeModal();
    await sleep(50);

    scalpShooting({
      userId,
      userNickname,
      currentAction: "DevicePairingBluetooth",
    });
  };

  return (
    <BottomSheetModal
      closeModal={closeModal}
      titleSection={t("{{this}} 정보", { this: t("스캐너") })}
      btnSection={
        <button className="my-btn-primary w-full" onClick={handleChangeScanner}>
          {t("스캐너 변경하기")}
        </button>
      }
      isOpened={isOpened}
      isCloseModalOutsideClick={true}
    >
      <div className="grid gap-sp-16 px-inner-padding py-sp-16 md:grid-cols-2">
        {scannerInfos.map((info, idx) => (
          <div key={idx} className="grid grid-cols-2 gap-sp-8">
            <div className="text-base-500 text-sm">{info.label}</div>
            <div className="text-sm">{info.info}</div>
          </div>
        ))}
      </div>
    </BottomSheetModal>
  );
};

export const useCheckScannerModal = () => {
  const { modal, openModal, closeModal } = useModal(modalIds["check-scanner"]);

  const openModalCallback = useCallback(() => {
    openModal();
  }, [openModal]);

  return {
    openModal: openModalCallback,
    closeModal,
    isOpened: modal.isOpened,
  };
};
